import {
    REGISTER_WIZARD_ROUTES,
    REGISTER_TYPES,
    MY_PERMISSIONS,
    REGISTERS_PERMISSIONS
} from '@/constants'
import { myPermissionsGuard } from '@src/router/guards'

export default {
    name: REGISTER_WIZARD_ROUTES.INTERNAL_AUDITS.INDEX.name,
    component: () =>
        import(
            '@/containers/RegisterWizard/InternalAudits/RegisterOfInternalAudits'
        ),
    path: 'internal-audits',
    props: true,
    redirect: to => ({
        name: REGISTER_WIZARD_ROUTES.INTERNAL_AUDITS.WIZARD.name,
        params: { ...to.params }
    }),
    meta: {
        requiresAuth: true,
        register: REGISTER_TYPES.INTERNAL_AUDITS
    },
    children: [
        {
            path: 'wizard',
            name: REGISTER_WIZARD_ROUTES.INTERNAL_AUDITS.WIZARD.name,
            component: () =>
                import('@/components/registers/internal-audits/WizardTab'),
            props: true,
            meta: {
                pageTitle: 'REGISTERS.INTERNAL_AUDITS.TITLE',
                title: 'REGISTERS.INTERNAL_AUDITS.WIZARD_TITLE',
                withScaling: true,
                requiresAuth: true,
                register: REGISTER_TYPES.INTERNAL_AUDITS,
                shouldSkipRouteInHistory: false,
                shouldKeepPreviousRoute: true,
                guards: [myPermissionsGuard],
                permissions: [
                    MY_PERMISSIONS.INTERNAL_AUDIT_ACCESS,
                    REGISTERS_PERMISSIONS.AUDIT_REGISTER
                ]
            }
        },
        {
            path: 'properties',
            name: REGISTER_WIZARD_ROUTES.INTERNAL_AUDITS.PROPERTIES.name,
            component: () => import('@/components/registers/PropertiesTab'),
            props: true,
            meta: {
                pageTitle: 'REGISTERS.INTERNAL_AUDITS.TITLE',
                withScaling: true,
                requiresAuth: true,
                register: REGISTER_TYPES.INTERNAL_AUDITS,
                shouldSkipRouteInHistory: true,
                guards: [myPermissionsGuard],
                permissions: [
                    MY_PERMISSIONS.INTERNAL_AUDIT_ACCESS,
                    REGISTERS_PERMISSIONS.AUDIT_REGISTER
                ]
            }
        },
        {
            path: 'discussions',
            name: REGISTER_WIZARD_ROUTES.INTERNAL_AUDITS.DISCUSSIONS.name,
            component: () => import('@/components/registers/Discussions'),
            props: true,
            meta: {
                pageTitle: 'REGISTERS.INTERNAL_AUDITS.TITLE',
                withScaling: true,
                requiresAuth: true,
                register: REGISTER_TYPES.INTERNAL_AUDITS,
                shouldSkipRouteInHistory: true,
                guards: [myPermissionsGuard],
                permissions: [
                    MY_PERMISSIONS.INTERNAL_AUDIT_ACCESS,
                    REGISTERS_PERMISSIONS.AUDIT_REGISTER
                ]
            }
        }
    ]
}
